import { render } from "./ContextMenu.vue?vue&type=template&id=6a1a070a&scoped=true&ts=true"
import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"

import "./ContextMenu.vue?vue&type=style&index=0&id=6a1a070a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1a070a"]])

export default __exports__